/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type ReasonForReturn =
  typeof ReasonForReturn[keyof typeof ReasonForReturn];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReasonForReturn = {
  BENEFICIARY_SORT_CODE_OR_ACCOUNT_UNKNOWN:
    'BENEFICIARY_SORT_CODE_OR_ACCOUNT_UNKNOWN',
  BENEFICIARY_ACCOUNT_CLOSED: 'BENEFICIARY_ACCOUNT_CLOSED',
  BENEFICIARY_ACCOUNT_STOPPED: 'BENEFICIARY_ACCOUNT_STOPPED',
  BENEFICIARY_DECEASED: 'BENEFICIARY_DECEASED',
  ACCOUNT_CANNOT_BE_IDENTIFIED: 'ACCOUNT_CANNOT_BE_IDENTIFIED',
  BENEFICIARY_ACCOUNT_NAME_DOES_NOT_MATCH_BENEFICIARY_ACCOUNT_NUMBER:
    'BENEFICIARY_ACCOUNT_NAME_DOES_NOT_MATCH_BENEFICIARY_ACCOUNT_NUMBER',
  RETURN_REQUESTED_BY_SENDER_OF_ORIGINAL_PAYMENT:
    'RETURN_REQUESTED_BY_SENDER_OF_ORIGINAL_PAYMENT',
  ACCOUNT_IS_NOT_IN_CURRENCY_QUOTED: 'ACCOUNT_IS_NOT_IN_CURRENCY_QUOTED',
  BENEFICIARY_IS_NOT_EXPECTING_FUNDS_OR_INSTRUCTED_RETURN:
    'BENEFICIARY_IS_NOT_EXPECTING_FUNDS_OR_INSTRUCTED_RETURN',
  TERMS_AND_CONDITIONS_OF_ACCOUNT_DO_NOT_PERMIT_CREDITING_OF_FUNDS:
    'TERMS_AND_CONDITIONS_OF_ACCOUNT_DO_NOT_PERMIT_CREDITING_OF_FUNDS',
  SENDING_FPS_INSTITUTION_ACTION_REQUIRED:
    'SENDING_FPS_INSTITUTION_ACTION_REQUIRED',
  ACCOUNT_TRANSFERRED: 'ACCOUNT_TRANSFERRED',
  PAYMENT_CANNOT_BE_APPLIED_BECAUSE_OF_BENEFICIARY_SENSITIVITIES:
    'PAYMENT_CANNOT_BE_APPLIED_BECAUSE_OF_BENEFICIARY_SENSITIVITIES',
  OTHER: 'OTHER',
} as const;
